const Header = () => {
    return(
        <>
           <h1 className="main-title">Memory Game</h1>
        </>
    )
}

export default Header;